import type { ReactNode } from "react";

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="empty">
      <p className="empty__title">{title}</p>
      {description ? <p style={{ maxWidth: "38ch" }}>{description}</p> : null}
      {action}
    </div>
  );
}
